import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import log from "loglevel";
import "bootstrap/dist/css/bootstrap.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import configureStore from "./store/configureStore";
import App from "./components/App";
import "./icons";
import "./index.css";
import "@avlino-inc/alenza-react/lib/css/style.css";

if (process.env.NODE_ENV === "development") {
  log.enableAll();
  log.info("Logging Enabled.");
} else {
  log.disableAll();
  // Disabling all logging in production
}

const store = configureStore();

const ConnectedApp = () => (
  <Provider store={store}>
    <App />
    <ReduxToastr
      timeOut={5000}
      newestOnTop={false}
      preventDuplicates
      position="bottom-left"
      transitionIn="fadeIn"
      transitionOut="fadeOut"
      progressBar
      closeOnToastrClick
    />
  </Provider>
);

const rootElement = document.getElementById("root");

render(<ConnectedApp />, rootElement);
